import { useEffect } from 'react';

import { useHash } from '@mantine/hooks';

export const useScrollHashIntoView = () => {
    const [hash] = useHash();

    useEffect(() => {
        if (!hash) return;

        const element = document.getElementById(hash.replace('#', ''));

        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [hash]);

    return null;
};
